// extracted by mini-css-extract-plugin
export default {"avatar":"src-modules-account-user-profile-AvatarForm-style__avatar_wiZru","button":"src-modules-account-user-profile-AvatarForm-style__button_L4Yij"};